<template>
  <div>
    <div class="modal-title">{{ $t('change_residence_time') }}</div>
    <div v-if="isStay(target.destination.genreIds)" class="modal-content">
      <p class="text-xs text-label">{{ $t('arr_time') }}</p>
      <arrival-time-select v-model="arrivalTime" />
      <p class="text-xs text-label mt-4">{{ $t('dep_time') }}</p>
      <departure-time-select v-model="departureTime" />
    </div>
    <div v-else class="modal-content">
      <div class="hidden">
        <p class="text-xs text-label">{{ $t('arrival_time') }}</p>
        <arrival-time-select v-model="arrivalTime" />
      </div>
      <p class="text-xs text-label mt-4">{{ $t('residence_time_label') }}</p>
      <time-select v-model="time" />
    </div>
    <div class="modal-button">
      <a class="button-primary block" @click="callback(target.destination, getVisitTime(target.destination.genreIds, time), arrivalTime)">{{ $t('setting') }}</a>
    </div>
  </div>
</template>

<script>
import ArrivalTimeSelect from "./ArrivalTimeSelect"
import DepartureTimeSelect from "./DepartureTimeSelect"
import TimeSelect from "./TimeSelect"

export default {
  components: {
    ArrivalTimeSelect,
    DepartureTimeSelect,
    TimeSelect
  },
  props: {
    target: {
      type: Object,
      required: true
    },
    callback: {
      type: Function,
      required: true
    }
  },
  data () {
    let tmp_dep_time = this.target.route.arrivalTime.clone()
    tmp_dep_time.add(this.target.destination.visit, 'm')
    return {
      time: this.target.destination.visit,
      arrivalTime: this.target.route.arrivalTime,
      departureTime: tmp_dep_time
    }
  },
  watch: {
    target: function (val) {
      this.arrivalTime = val.route.arrivalTime
      let tmp_dep_time = this.target.route.arrivalTime.clone()
      this.departureTime = tmp_dep_time.add(val.destination.visit, 'm')
      this.time = tmp_dep_time.diff(val.route.arrivalTime, 'minutes')
    }
  },
  methods: {
    isStay: function(genreIds) {
      return genreIds.includes('stay')
    },
    getVisitTime: function(genreIds, time) {
      if (genreIds.includes('stay')) {
        let visit = this.departureTime.diff(this.arrivalTime, 'minutes')
        // momentで時刻を選択させると日付が変わってしまい発着時刻から滞在を計算するとマイナスや24時間以上になることがあるので調整
        if (visit > 1440) {
          visit -= 1440
        } else if (visit < 0) {
          visit += 1440
        }
        return visit
      } else {
        return time
      }
      
    }
  }
}
</script>
